import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';

import {useHttpClient} from '../../../common/hook/http';
import Loader from '../../../common/component/Loader/Loader';

import {Button, Modal} from 'react-bootstrap';

import * as IconFi from 'react-icons/fi';

const ModalDynamic = props => {
    const navigate = useNavigate()
    const {callAPI} = useHttpClient();

    // ----------------------------------------------------------------------------------------------------- show & hide

    const handlePopstate = () => {

        if (document.querySelectorAll('.modal').length < 2)
            window.removeEventListener('popstate', handlePopstate)

        props.onHide()

    }

    const onShowHandler = () => {

        document.getElementById('modalDynamic').style.paddingRight = document.querySelector('body').style.paddingRight

        navigate('#modalDynamic')
        window.addEventListener('popstate',  handlePopstate);

    }

    const onHideHandler = () => {

        navigate(-1)

    }

    // ------------------------------------------------------------------------------------------------------ fetch data

    const [data, setData] = useState(null);

    useEffect(() => {

        if (props.data) {

            setData(null)

            const fetchData = async () => {
                try {
                    const responseData = await callAPI(
                        `${props.data.url}`,
                        'GET',
                        null,
                        {'Content-Type': 'application/json'},
                    )

                    setData(responseData)

                } catch (err) {
                    console.error(err)
                }
            }

            fetchData()
        }

    }, [callAPI, props.data]);

    // -----------------------------------------------------------------------------------------------------------------

    return (
        <Modal id="modalDynamic" aria-labelledby="modalDynamicTitle" {...props} backdrop={false} fullscreen onHide={onHideHandler} onShow={onShowHandler} className="ltr bg-body" dialogClassName={`rtl${data ? ' h-auto' : ''}`} contentClassName="container-lg px-0">
            <Modal.Header className="position-sticky top-0">
                <Button variant="link" onClick={onHideHandler} className="my-md-1 text-reset border-0 btn-icon"><IconFi.FiArrowRight size={24} className="sw-1 m-2"/></Button>
                <Modal.Title className="me-4 pe-3 flex-grow-1 text-center fs-5 text-truncate">{props.data?.title}</Modal.Title>
            </Modal.Header>
            {
                data ? (
                    <Modal.Body clssName="overflow-visible pt-0 pb-4 pb-xl-5" dangerouslySetInnerHTML={{__html: data}}/>
                ) : (
                    <Modal.Body className="d-flex justify-content-center align-items-center">
                        <Loader text="در حال دریافت اطلاعات"/>
                    </Modal.Body>
                )
            }
        </Modal>
    )
}

export default ModalDynamic;